/**
 * Invert dictionary keys and values.
 * It's useful when you want to normalize (translate back to original) a minified object.
 * { 'from': 'to' } returns { 'to': 'from' }
 * @param {Object.<string, string>} dictionary
 * @returns {Object.<string, string>}
 */
const invertDictionary = dictionary => Object
  .entries(dictionary)
  .reduce((accumulator, [key, value]) => {
    accumulator[value] = key;

    return accumulator;
  }, {});

module.exports = invertDictionary;
